import { FC } from "react";
import { capitalize, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { budgetPeriodUnits } from "@/components/pages/budgets-and-alerts/components/drawer/budget-alert-create-edit-drawer/components/budgets/components/create-budget/utils/constants/date-selection";
import { useAppSelector } from "@/store/hooks";
import { currentBudgetPeriodSelector } from "@/store/budgets/selectors/current-budget/data-selectors/currentBudgetPeriodSelector";
import { HighchartsProvider } from "@/storybook/c8r-highcharts/common/components/HighchartsProvider";
import { MultiTypeHighcharts } from "@/storybook/c8r-highcharts/MultiTypeHighcharts";
import { budgetChartDataLoadingSelector } from "@/store/budgets/selectors/current-budget/chart/budgetChartDataLoadingSelector";
import { budgetHighChartDataSelector } from "@/store/budgets/selectors/current-budget/chart/budgetHighChartDataSelector";
import { getHighChartsYAxisLabelsFormatter } from "@/storybook/c8r-highcharts/common/utils/helpers/getHighChartsYAxisLabelsFormatter";
import { budgetChartSummarizedWithBudgetDataSelector } from "@/store/budgets/selectors/current-budget/chart/budgetChartSummarizedWithBudgetDataSelector";
import { money } from "@/utils/numeral/money";
import { getHighChartsColumnDataLabels } from "@/storybook/c8r-highcharts/common/utils/helpers/getHighChartsColumnDataLabels";

export const BudgetsDrawerHighChart: FC = () => {
  const period = useAppSelector(currentBudgetPeriodSelector);
  const chartDataLoading = useAppSelector(budgetChartDataLoadingSelector);

  const totals = useAppSelector(budgetChartSummarizedWithBudgetDataSelector);
  const data = useAppSelector(budgetHighChartDataSelector);

  const lastValue = totals?.at(-1)?.total ?? 0;

  return (
    <Stack p={2} flex={1} width="50%" borderLeft={1} borderColor={grey[300]}>
      <Typography variant="body1" fontWeight="medium">
        Cost Data
      </Typography>

      <Stack direction="row" spacing={1} mt={2} mb={1}>
        <Typography variant="subtitle2" color="text.secondary" fontWeight="400">
          Last {capitalize(budgetPeriodUnits[period ?? ""] ?? "")} -
        </Typography>

        <Typography variant="body1" fontWeight="medium" component="span">
          {money(lastValue)}
        </Typography>
      </Stack>

      <HighchartsProvider>
        <Stack height={350}>
          <MultiTypeHighcharts
            showLegends
            showDataLabels
            maxHeight={350}
            chartData={data}
            chartType="column"
            chartScale="linear"
            loading={chartDataLoading}
            columnDataLabels={columnDataLabels}
            yAxisLabelsFormatter={yAxisLabelsFormatter}
          />
        </Stack>
      </HighchartsProvider>
    </Stack>
  );
};

const yAxisLabelsFormatter = getHighChartsYAxisLabelsFormatter("cost");

const columnDataLabels = getHighChartsColumnDataLabels(
  "column",
  "cost",
  "#000",
);
